import { defineMessages } from 'react-intl';

export default defineMessages({
  productPending: {
    id: 'productPending',
    defaultMessage: 'Design pending',
  },
  productCompleted: {
    id: 'productCompleted',
    defaultMessage: 'Design completed',
  },
});
